<template>
  <div>
    <v-card flat class="pa-1" rounded="lg">
      <v-card-text class="white">
        <v-row :class="{ 'justify-center': $vuetify.breakpoint.xs }" dense>
          <!-- data type: test or production -->
          <v-col cols="12">
            <div class="d-flex flex-wrap">
              <v-radio-group v-model="dataType" hide-details="auto" row>
                <v-radio
                  label="Ver reporte con datos de prueba"
                  value="00"
                ></v-radio>
                <v-radio
                  label="Ver reporte con datos de producción"
                  value="01"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-col>

          <!-- form filters -->
          <v-col cols="12">
            <v-form @submit.prevent="filterLastPurchases">
              <v-row class="mt-5 align-center">
                <v-col cols="12" sm="3" class="py-1">
                  <date-picker-2
                    v-model="date.start"
                    label="Fecha inicio"
                  ></date-picker-2>
                </v-col>
                <v-col cols="12" sm="3" class="py-1">
                  <date-picker-2
                    v-model="date.end"
                    label="Fecha fin"
                  ></date-picker-2>
                </v-col>
                <v-col cols="12" sm="6" class="py-1">
                  <v-text-field
                    v-model="filter.BarCode"
                    label="Cód. comprobante"
                    hide-details
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" class="py-1">
                  <v-text-field
                    v-model="filter.ID_PurchaseOrder"
                    label="Orden de compra"
                    hide-details
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" class="py-1">
                  <v-text-field
                    v-model="filter.ID_PurchaseLegalInvoiceNumber"
                    label="Comprobante"
                    hide-details
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" class="py-1">
                  <v-text-field
                    v-model="filter.ID_Producto"
                    label="Código"
                    hide-details
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-1">
                  <v-text-field
                    v-model="filter.ItemName"
                    label="Descripción"
                    hide-details
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                    <v-select
                        outlined
                        dense
                        attach
                        clearable
                        hide-details
                        :items="PurchaseOrderTypeItems"
                        :label="'Tipo de factura'"
                        v-model="filter.PurchaseOrderType"
                    ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  lg="3"
                  class="py-1 text-center text-sm-left"
                >
                  <v-btn class="mr-1" color="primary" type="submit">
                    <v-icon>mdi-filter</v-icon>
                    Filtrar
                  </v-btn>
                  <v-btn @click="cleanFilters" class="ml-1" color="warning">
                    <v-icon>mdi-backspace-outline</v-icon>
                    Limpiar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- data table -->
      <DxDataGrid
        :data-source="purchases"
        :show-borders="true"
        :column-auto-width="true"
        @exporting="onExporting"
        style="max-height: 600px"
        :paging="{ enabled: false }"
      >
        <DxScrolling
          row-rendering-mode="virtual"
          showScrollbar="always"
          useNative="false"
        />
        <DxExport :enabled="true" />
        <DxColumn data-field="PurchaseOrderDate" caption="Fecha de creacion" />
        <DxColumn data-field="ID_PurchaseOrder" caption="Orden de compra" />
        <DxColumn
          caption="Tipo de factura"
          :calculate-cell-value="
            (rowData) => getDocumentName(rowData.PurchaseOrderType)
          "
        />
        <DxColumn
          data-field="ID_PurchaseLegalInvoiceNumber"
          caption="Comprobante"
        />
        <DxColumn data-field="PurchaseInvoiceDate" caption="Fecha factura" />
        <DxColumn data-field="ID_Item" caption="Código" />
        <DxColumn data-field="BarCode1" caption="Cód. comprobante" />
        <DxColumn
          caption="Cantidad"
          :calculate-cell-value="
            (rowData) =>
              formatValue(rowData.PurchaseOrderType, rowData.ItemQuantity)
          "
        />
        <DxColumn data-field="ID_ItemBatch" caption="Lote" />
        <DxColumn data-field="ItemName" caption="Descripción" />
        <DxColumn
          caption="Precio unitario"
          :calculate-cell-value="
            (rowData) =>
              formatDecimalValue(
                rowData.PurchaseOrderType,
                rowData.ItemUnitCost
              )
          "
        />
        <DxColumn
          caption="Exento"
          :calculate-cell-value="
            (rowData) =>
              formatDecimalValue(rowData.PurchaseOrderType, rowData.ItemExento)
          "
        />
        <DxColumn
          caption="No sujeto"
          :calculate-cell-value="
            (rowData) =>
              formatDecimalValue(
                rowData.PurchaseOrderType,
                rowData.ItemNoSujeto
              )
          "
        />
        <DxColumn
          caption="Total"
          :calculate-cell-value="
            (rowData) =>
              formatDecimalValue(rowData.PurchaseOrderType, rowData.total)
          "
        />
      </DxDataGrid>
    </v-card>
    <block v-model="loading"></block>
    <alert v-model="alert.show" :type="alert.type" :title="alert.title">
      {{ alert.message }}
    </alert>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxExport,
  DxScrolling,
} from "devextreme-vue/data-grid";
import { printToExcel } from "../../../helpers/printToexcel";
import DatePicker2 from "../../../components/DatePicker2.vue";
import moment from "moment";

export default {
  name: "ProviderLastPurchases",
  components: { DatePicker2, DxDataGrid, DxColumn, DxScrolling, DxExport },
  props: {
    win: {
      type: Object,
      default: () => ({}),
    },
    provider: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    dataType: "01",
    date: {
      start: "",
      end: "",
    },
    filter: {
      ID_Producto: "",
      ItemName: "",
      BarCode: "",
      ID_PurchaseLegalInvoiceNumber: "",
      ID_PurchaseOrder: "",
      PurchaseOrderType: "",
    },
    loading: false,
    purchases: [],
    PurchaseOrderTypeItems: [
      {
        text: 'Crédito Fiscal',
        value: 'CCF',
      },
      {
        text: 'Consumidor Final',
        value: 'FAF',
      },
      {
        text: 'Nota de Crédito',
        value: 'NC',
      },
      {
        text: 'Nota de Débito',
        value: 'ND',
      },
      {
        text: 'Factura Exportación',
        value: 'FE',
      },
      {
        text: 'Declaracion de Mercancías',
        value: 'DDM',
      },
      {
        text: 'Mandamiento de Ingreso',
        value: 'MDI',
      },
      {
        text: 'Recibo o Doc sin IVA',
        value: 'RSI',
      },
      {
        text: 'Factura de Importación',
        value: 'FI',
      },
    ],
    alert: {
      show: false,
      type: "error",
      title: "Error",
      message: "",
    },
  }),
  computed: {
    dateYMD() {
      return {
        start: this.formatDate(this.date.start),
        end: this.formatDate(this.date.end),
      };
    },
  },
  methods: {
    showError(message) {
      this.alert.message = message;
      this.alert.type = "error";
      this.alert.title = "Error";
      this.alert.show = true;
    },
    formatDate(dateDMY) {
      return moment(dateDMY, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
    getDocumentName(PurchaseOrderType) {
      switch (PurchaseOrderType) {
        case "CCF":
          return "Crédito Fiscal";
        case "FAF":
          return "Consumidor Final";
        case "NC":
          return "Nota de Crédito";
        case "ND":
          return "Nota de Débito";
        case "FE":
          return "Factura Exportación";
        case "DDM":
          return "Declaracion de Mercancías";
        case "MDI":
          return "Mandamiento de Ingreso";
        case "RSI":
          return "Recibo o Doc sin IVA";
        case "FI":
          return "Factura de Importación";
      }
      return "";
    },
    formatDecimalValue(rowDataPurchaseOrderType, value) {
      if (rowDataPurchaseOrderType === "NC") {
        return "-" + value.toFixed(2);
      }
      return value.toFixed(2);
    },
    formatValue(rowDataPurchaseOrderType, value) {
      if (rowDataPurchaseOrderType === "NC") {
        return -1 * value;
      }
      return value;
    },
    onExporting(e) {
      printToExcel(
        e,
        `Historial de compras - ${this.provider.ID_Provider}`,
        null,
        `Historial de compras - ${this.provider.ID_Provider} - ${this.provider.name}`
      );
    },
    async cleanFilters() {
      const currentDate = moment();
      this.date.end = currentDate.format("DD/MM/YYYY");
      this.date.start = currentDate.subtract(15, "days").format("DD/MM/YYYY");
      this.filter = {
        ID_Producto: "",
        ItemName: "",
        BarCode: "",
        ID_PurchaseLegalInvoiceNumber: "",
        ID_PurchaseOrder: "",
        PurchaseOrderType: "",
      };
      await this.filterLastPurchases();
    },
    async filterLastPurchases() {
      try {
        this.loading = true;
        const params = {
          ID_Provider: this.provider.ID_Provider,
          dataType: this.dataType,
          startDate: this.dateYMD.start,
          endDate: this.dateYMD.end,
          ...this.filter,
        };
        const { data } = await this.$API.providers.getLastPurchasesByProvider(
          this.$clone(params)
        );
        this.purchases = data;
      } catch (err) {
        console.error(err);
        const errorMsg = this.$parseError(err);
        this.showError(`Ha ocurrido un error, intente nuevamente. ${errorMsg}`);
      } finally {
        this.loading = false;
      }
    },
  },
  async beforeMount() {
    // set range 15-day range from now backward
    const currentDate = moment();
    this.date.end = currentDate.format("DD/MM/YYYY");
    this.date.start = currentDate.subtract(15, "days").format("DD/MM/YYYY");
    await this.filterLastPurchases();
  },
};
</script>